import { FormControl, InputLabel } from "@material-ui/core";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import {
  ICardElementWithChildren,
  IPeriod,
  IPeriodLevel,
} from "backend/model/model";
import React from "react";
import Select from "@material-ui/core/Select";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import MenuItem from "@material-ui/core/MenuItem";
const usePeriodSelectorStyles = makeThemedStyles("PeriodSelector", (theme) => ({
  root: {
    display: "inline-flex",
    margin: "10px",
    background: "white",
    borderRadius: "10px",
  },
  title: {
    color: "rgba(16, 41, 118, 1)",
  },
  titleTypeName: {
    color: "rgba(16, 41, 118, 1)",
  },
  formControl: {},
}));

const PeriodSelectorDesign = (
  props: React.PropsWithChildren<{
    periodlevels: IPeriodLevel[];
    selectedLevel?: IPeriodLevel;
    selectedPeriod?: IPeriod;
    onSelectLevel?: (value: string) => void;
    onSelectPeriod?: (value: string) => void;
  }>
) => {
  const styles = usePeriodSelectorStyles();
  const { periodlevels } = props;

  return (
    <div className={styles.root}>
      <FormControl variant="outlined" className={styles.formControl}>
        <Select
          id="selectPeriodLevel"
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left",
            },
            getContentAnchorEl: null,
            disableScrollLock: true,
          }}
          defaultValue={props.selectedLevel?.id || ""}
          value={props.selectedLevel?.id || ""}
          style={{ display: periodlevels.length === 1 ? "none" : undefined }}
          onChange={(e) => {
            if (props.onSelectLevel && typeof e.target.value === "string") {
              props.onSelectLevel(e.target.value);
            }
          }}
        >
          {periodlevels.map((level) => {
            return (
              <MenuItem
                key={level.id}
                value={level.id}
                selected={level.id === props.selectedLevel?.id}
              >
                {level.name}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <FormControl variant="outlined" className={styles.formControl}>
        <Select
          id="selectPeriod"
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left",
            },
            getContentAnchorEl: null,
            disableScrollLock: true,
          }}
          value={props.selectedPeriod?.id || ""}
          defaultValue={props.selectedPeriod?.id || ""}
          onChange={(e) => {
            console.log("onSelectPeriod onChange ", e);
            if (props.onSelectPeriod && typeof e.target.value === "string") {
              props.onSelectPeriod(e.target.value);
            }
          }}
        >
          {props.selectedLevel
            ? props.selectedLevel.periods.map((p) => {
                return (
                  <MenuItem
                    value={p.id}
                    key={p.id}
                    selected={p.id === props.selectedPeriod?.id}
                  >
                    {p.name}
                  </MenuItem>
                );
              })
            : null}
        </Select>
      </FormControl>
    </div>
  );
};

export default PeriodSelectorDesign;
